import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      // Obtener la ruta guardada o redirigir según el rol
      const redirectPath = localStorage.getItem('redirectAfterLogin');
      localStorage.removeItem('redirectAfterLogin');
      
      // Si hay una ruta guardada, usarla; si no, redirigir según el rol
      if (redirectPath) {
        navigate(redirectPath);
      } else {
        // Verificar el rol del usuario después del login
        // Los proveedores (rol 2) van al home, los admin al dashboard
        const userRole = localStorage.getItem('userRole');
        if (userRole === '2') {
          navigate('/');
        } else {
          navigate('/dashboard');
        }
      }
    } else {
      setError(result.message || 'Error al iniciar sesión. Verifique sus credenciales.');
    }
    
    setLoading(false);
  };

  return (
    <div 
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '2rem 1rem'
      }}
    >
      <Container className="d-flex justify-content-center">
        <Card className="shadow-lg border-0" style={{ maxWidth: '450px', width: '100%' }}>
          <Card.Body className="p-4 p-md-5">
            <div className="text-center mb-4">
              <img 
                src="/LOGO-DIRESA.png" 
                alt="Logo DIRESA" 
                className="mb-3"
                style={{ maxHeight: '80px', width: 'auto' }}
              />
              <h2 className="fw-bold text-primary mb-2">Sistema de Cotizador</h2>
              <p className="text-muted">Inicie sesión para continuar</p>
            </div>

            {error && (
              <Alert variant="danger" dismissible onClose={() => setError('')} className="mb-4">
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                {error}
              </Alert>
            )}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">
                  <i className="bi bi-envelope me-2"></i>
                  Correo electrónico
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="tu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                  size="lg"
                  className="border-2"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <Form.Label className="fw-semibold mb-0">
                    <i className="bi bi-lock-fill me-2"></i>
                    Contraseña
                  </Form.Label>
                  <Link 
                    to="/forgot-password" 
                    className="text-decoration-none small"
                    style={{ fontSize: '0.875rem' }}
                  >
                    ¿Olvidaste tu contraseña?
                  </Link>
                </div>
                <Form.Control
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                  size="lg"
                  className="border-2"
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                disabled={loading}
                size="lg"
                className="w-100 mb-3 fw-semibold"
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Iniciando sesión...
                  </>
                ) : (
                  <>
                    <i className="bi bi-box-arrow-in-right me-2"></i>
                    Iniciar Sesión
                  </>
                )}
              </Button>
            </Form>

            <div className="text-center">
              <p className="text-muted mb-2">
                ¿No tienes una cuenta?{' '}
                <Link to="/registro" className="text-decoration-none fw-semibold">
                  Regístrate aquí
                </Link>
              </p>
              <Link to="/" className="text-decoration-none text-muted small">
                <i className="bi bi-arrow-left me-1"></i>
                Volver al inicio
              </Link>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default Login;
